const FALLBACK_REDIRECT = "/dashboard/my-profile";

export function resolveSafeRedirect(redirect: string | null | undefined) {
  if (!redirect) {
    return FALLBACK_REDIRECT;
  }

  if (!redirect.startsWith("/") || redirect.startsWith("//")) {
    return FALLBACK_REDIRECT;
  }

  if (redirect.startsWith("/auth")) {
    return FALLBACK_REDIRECT;
  }

  return redirect;
}

export function toLoginRedirect(currentPath: string) {
  const encoded = encodeURIComponent(currentPath || "/");
  return `/auth/login?redirect=${encoded}`;
}

export function withRedirect(path: string, redirect: string | null | undefined) {
  if (!redirect) return path;
  const safe = resolveSafeRedirect(redirect);
  return `${path}?redirect=${encodeURIComponent(safe)}`;
}
